<template>
  <v-card class="report-row" flat>
    <div class="row total">
      <div class="col-6">{{day.date | sloDate}}</div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="font-weight-bold">Naprava</th>
                <th class="font-weight-bold">Neto</th>
                <th class="font-weight-bold">DDV</th>
                <th class="font-weight-bold">Bruto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="device in day.devices" :key="device.name">
                <td>{{ device.name }}</td>
                <td :inner-html.prop="device.taxable_amount_total | price(2)"></td>
                <td :inner-html.prop="device.tax_amount_total | price(2)"></td>
                <td :inner-html.prop="device.total | price(2)"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    day: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      taxLevelsOpen: false
    }
  }
}
</script>

<style lang="scss" scoped>
.report-row {
  padding: 0 15px;
  margin: 5px;
  margin-bottom: 15px;
  font-size: 20px;

  .total {
    font-size: 30px;
    font-weight: bold;
  }
}
</style>
